import React from 'react';

function getFlat(note) {
    if(note.includes('b')) {
        return <span>&#9837;</span>
    }
    else {
        return <span></span>
    }
}
function getNoteJsx(note, idx, len) {
        let flat = getFlat(note)
        note = note.replace('b', '')

        if(note.includes('b')) {
            return <span>{note}{flat}</span>
        }
        if(idx == len-1 && len >1) {
            return <span> and <b>{note}{flat}</b></span>
        }
        else if(len==1) {
            return (<b> {note}{flat}</b>)
        }
       return <span><b>{note}{flat}</b>, </span>
}


function getNoteList(props) {
    let counter=0;
    let scaleFlat = getFlat(props.scale)
    let scaleArray = props.scale.split(' ')
    let scalePrefix = scaleArray[0].replace('b','')
    return (
        <div>

        <label>
            <span>Click on the fretboard to identify all occurrences of </span>

            {props.notes.map(note => (
                <span>{getNoteJsx(note, counter++, props.notes.length)}</span>
            ))}
            <span> in the key of <b>{scalePrefix}{scaleFlat} {scaleArray[1]}</b>.

            </span>
        &nbsp;
        </label>
        </div>
    )
}

export default function InstructionLabel(props) {
    return (
        <div>
            {getNoteList(props)}
        </div>
    );
}
